import React, {useEffect} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

const MainSlider = () => {
  useScrollToTop();

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 8000,
    fade: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    pauseOnHover: false,
    cssEase: 'linear',
    prevArrow: <div className="divine-prev" />,
    nextArrow: <div className="divine-next" />
  };

  const slides = [
    { imageUrl: '/assets/Banner/Slider1.jpg' },
    { imageUrl: '/assets/Banner/Slider2.jpg' },
    { imageUrl: '/assets/Banner/Slider3.jpg' }
  ];

  return (
    <div className="spiritual-carousel">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="aura-slide">
            <div className="divine-frame">
              <div
                className="divine-bg"
                style={{ backgroundImage: `url(${slide.imageUrl})` }}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default MainSlider;
